// tslint:disable: max-line-length
export const bodyWithLink = `
  Zamknij i uruchom ponownie przeglądarkę. Jeśli to nie pomoże, przejdź do <a href="{supportCenterLink}" target="_blank">Centrum wsparcia</a>.
`;
